/**
 *  CDB客人资料参团记录查询
 */
import { axios } from '@/utils/request'

const subPath = '/cdb/customer/operationLog'

export default {
  query,
  queryNew
}

// 分页查询
function query (parameter) {
  return axios({
    url: `${subPath}/query`,
    method: 'get',
    params: { ...parameter, 'page.curPage': parameter.curPage, 'page.pageSize': parameter.pageSize }
  })
}

// 分页查询
function queryNew (parameter) {
  return axios({
    url: `${subPath}/v2/query`,
    method: 'get',
    params: { ...parameter, 'page.curPage': parameter.curPage, 'page.pageSize': parameter.pageSize }
  })
}

